
import React, {Component} from 'react';
import JobControlBoardTable from '../workdoc/jobcontrol/JobControlBoardTable';
import PrintPreview from './PrintPreview';
import WorkdocStore from '../../stores/WorkdocStore';
import ReportStore from '../../stores/ReportStore';

class PrintWorkJobPhoto extends Component {

  constructor(...args){
    super(...args)
    this.state = { data:[],files:[],all_page:[],loading:false }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
    
  }

  componentDidMount(){
    this.loadData()
  }

  loadWorkList(files) {
    let totalPage = files.length/4
    let that = this
    this.setState({ loading: true })
    ReportStore.loadReportWorkJobControlByWork(this.props.workNo,function (result) {
      new Array(4).fill('').map((item,index)=>{
        that.refs['jcbTable'+index].loadData(result.data,result.work_state) 
        return item
      })
      
    },function(error){
      that.setState({loading:false})
    })
  }

  loadData(){
    let that = this
    let {data,files} = this

    //this.refs.jobPhoto.loadData(item,workState)

    let dataRow = []
    WorkdocStore.loadFup(this.props.workNo,this.props.cat,function(result) {

      let i = 0
      let row = 0
      result.data.files.forEach(function(item,index) {
        if (i==0) {
          dataRow.push({
            left:item.url,
            right:''
          })
          i++
        } else if (i==1) {
          dataRow[row]['right'] = item.url
          i = 0
          row++
        }
      })    
      that.loadWorkList(result.data.files)
      that.setState({data:result.data,files:dataRow})
    })  
  }

  renderImg() {
    let {data,files} = this.state
    var i = 0
    return(
        files.map((item, index) => {
          i++
          if (i<=2) {
            delete files[index]

            let tagLeft = 'none'
            let tagRight = 'none'
            let imgNoneLeft = 'img-none'
            let imgNoneRight = 'img-none'
            if (item.left!='') {
              tagLeft = ''
              imgNoneLeft = ''
            }
            if (item.right!='') {
              tagRight = ''
              imgNoneRight = ''
            }
            return(
                <tr key={index}>
                  <td style={{display:tagLeft}} className="td-6pages"><img src={item.left} className={'img-6pages '+imgNoneLeft} /></td>
                  <td style={{display:tagRight}} className="td-6pages"><img src={item.right} className={'img-6pages '+imgNoneRight} /></td>
                </tr>
            )
          }  
        })
      )
  }

  render(){
    let {workNo} = this.props
    let {files,all_page,loading} = this.state
    let page = 0
    page = Math.ceil(files.length/2)
    for (var i=0;i<page;i++) {
      all_page.push(i)
    }
    let title = 'รายงานสถานะการซ่อมรถ '+this.props.workNo
    if (files.length==0) {
      return(
        <div>
          <PrintPreview
            loading={loading}
            size={'landscape'}
            leftBarTitle={title}
          >            
            <div key={0} className="img-list">
              <div><div  className='text-center'><h4>{title}</h4></div></div>
              <div>
                <JobControlBoardTable ref={'jcbTable0'} showWorkNo={false} showSearch={false}/>
              </div>
            </div>  
          </PrintPreview>  
        </div>    
      )
    } else {  
      return (
        <div>
          <PrintPreview
            loading={loading}
            size={'landscape'}
            leftBarTitle={title}
          >
          {  
            all_page.map((item, index) => {
              return(
                <div key={index} className="img-list">
                  <div><div  className='text-center'><h4>{title}</h4></div></div>
                  <div>
                    <JobControlBoardTable ref={'jcbTable'+index} showWorkNo={false} showSearch={false}/>
                  </div>
                  <div style={{textAlign:'center'}}>  
                    <table className="table table-img-list">
                      <tbody>
                        {this.renderImg()}
                      </tbody>
                    </table>
                  </div>  
                </div>
              )  
            })
          }            
          </PrintPreview>  
        </div>
      )
    }  
  }
}


export default PrintWorkJobPhoto;





// WEBPACK FOOTER //
// ./src/view/print/PrintWorkJobPhoto.js